import { newsApi } from './api';
import {
    ADD_PAYMENT_ENDPOINT,
    GET_PAYMENT_ENDPOINT,
    GET_PAYMENT_STATISTIC_ENDPOINT,
    PAYMENT_EDIT_ENDPOINT,
    REMOVE_PAYMENT_ENDPOINT
} from "./apiConstant";

export const PaymentService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getPaymentStatistics: build.query({
            query: (id) => ({
                url: `${GET_PAYMENT_STATISTIC_ENDPOINT}/${id ? id : 0}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getPayment: build.query({
            query: ({ id, pagination }) => ({
                url: `${GET_PAYMENT_ENDPOINT}/${id ? id : 0}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addPayment: build.mutation({
            query: (form) => ({
                url: `${ADD_PAYMENT_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editPayment: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${PAYMENT_EDIT_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removePayment: build.mutation({
            query: (id) => ({
                url: `${REMOVE_PAYMENT_ENDPOINT}/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetPaymentStatisticsQuery,
    useGetPaymentQuery,
    useAddPaymentMutation,
    useEditPaymentMutation,
    useRemovePaymentMutation
} = PaymentService